import React from 'react';
import ReactDOM from 'react-dom/client';
import { Route, RouterProvider, createRoutesFromElements, createBrowserRouter } from 'react-router-dom';
import './assets/styles/index.css';
import './assets/styles/react-datepicker.css'; // Import styles for the date picker
import './assets/styles/react-timepicker.css';
// import './assets/styles/bootstrap.custom.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import Login from './screens/LoginScreen'
import ForgetPassword from './screens/ForgetPasswordScreen'
import Dashboard from './screens/DashboardScreen';
import OrderScreen from './screens/OrderScreen';
import OrderDetailsScreen from './screens/OrderDetailsScreen';
import CustomerScreen from './screens/CustomersScreen';
import CustomerDetailScreen from './screens/CustomerDetailScreen';
import ManagerDashboardScreen from './screens/manager/DashboardScreen';
import OwnerDashboardScreen from './screens/owner/OwnerDashboardScreen.jsx';
import ManagerOrderScreen from '../src/screens/manager/ManagerOrderScreen';
import ManagerOrderDetailsScreen from './screens/manager/ManagerOrderDetailsScreen';
import ManagerCustomerScreen from './screens/manager/ManagerCustomerScreen';
import ServicesScreen from './screens/manager/ServicesScreen';
import ServicesDetailsScreen from './screens/manager/ServicesDetailsScreen';
import EmployeesScreen from './screens/manager/EmployeesScreen';
import EmployeesDetailsScreen from './screens/manager/EmployeesDetailsScreen';
import ManagerCustomerDetailsScreen from './screens/manager/ManagerCustomerDetailsScreen';
import InvoicingScreen from './screens/manager/InvoicingScreen';
import InvoicingDetailsScreen from './screens/manager/InvoicingDetailsScreen';
import SettingsScreen from './screens/manager/SettingsScreen';
import OwnerOrderScreen from './screens/owner/OwnerOrderScreen.jsx';
import OwnerOrderDetailsScreen from './screens/owner/OwnerOrderDetailsScreen.jsx';
import OwnerCustomerScreen from './screens/owner/OwnerCustomerScreen.jsx';
import OwnerCustomerDetailsScreen from './screens/owner/OwnerCustomerDetailsScreen.jsx';
import OwnerServicesScreen from './screens/owner/OwnerServicesScreen.jsx';
import OwnerServicesDetailsScreen from './screens/owner/OwnerServicesDetailsScreen.jsx';
import OwnerEmployeesScreen from './screens/owner/OwnerEmployeesScreen.jsx';
import OwnerEmployeesDetailsScreen from './screens/owner/OwnerEmployeesDetailsScreen.jsx';
import OwnerInvoicingScreen from './screens/owner/OwnerInvoicingScreen.jsx';
import OwnerInvoicingDetailsScreen from './screens/owner/OwnerInvoicingDetailsScreen.jsx';
import OwnerSettingsScreen from './screens/owner/OwnerSettingsScreen.jsx';
import SalesScreen from './screens/owner/SalesScreen.jsx';
import GratuityScreen from './screens/owner/GratuityScreen.jsx';
// import Header from './components/Header';


const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<App />}>
      <Route index={true} path='/login' element={<Login />}/>
      <Route  path='/forget-password' element={<ForgetPassword />}/>
      <Route  path='/' element={<Dashboard />}/>
      <Route  path='/orders' element={<OrderScreen />}/>
      <Route  path='/order-details' element={<OrderDetailsScreen />}/>
      <Route  path='/customers' element={<CustomerScreen />}/>
      <Route  path='/customer-details' element={<CustomerDetailScreen />}/>
      <Route  path='/manager/dashboard' element={<ManagerDashboardScreen />}/>
      <Route  path='/manager/orders' element={<ManagerOrderScreen />}/>
      <Route  path='/manager/orders/order-details' element={<ManagerOrderDetailsScreen />}/>
      <Route  path='/manager/customers' element={<ManagerCustomerScreen />}/>
      <Route  path='/manager/customers/customers-details' element={<ManagerCustomerDetailsScreen />}/>
      <Route  path='/manager/services' element={<ServicesScreen />}/>
      <Route  path='/manager/settings' element={<SettingsScreen />}/>
      <Route  path='/manager/services/services-details' element={<ServicesDetailsScreen />}/>
      <Route  path='/manager/employees' element={<EmployeesScreen />}/>
      <Route  path='/manager/employees/employees-details' element={<EmployeesDetailsScreen />}/>
      <Route  path='/manager/reports/invoicing' element={<InvoicingScreen />}/>
      <Route  path='/manager/reports/invoicing/invoicing-details' element={<InvoicingDetailsScreen />}/>
      <Route  path='/owner/dashboard' element={<OwnerDashboardScreen />}/>
      <Route  path='/owner/orders' element={<OwnerOrderScreen />}/>
      <Route  path='/owner/orders/order-details' element={<OwnerOrderDetailsScreen />}/>
      <Route  path='/owner/customers' element={<OwnerCustomerScreen />}/>
      <Route  path='/owner/customers/customers-details' element={<OwnerCustomerDetailsScreen />}/>
      <Route  path='/owner/services' element={<OwnerServicesScreen />}/>
      <Route  path='/owner/services/services-details' element={<OwnerServicesDetailsScreen />}/>
      <Route  path='/owner/employees' element={<OwnerEmployeesScreen />}/>
      <Route  path='/owner/employees/employees-details' element={<OwnerEmployeesDetailsScreen />}/>
      <Route  path='/owner/reports/invoicing' element={<OwnerInvoicingScreen />}/>
      <Route  path='/owner/reports/invoicing/invoicing-details' element={<OwnerInvoicingDetailsScreen />}/>
      <Route  path='/owner/settings' element={<OwnerSettingsScreen />}/>
      <Route  path='/owner/reports/sales' element={<SalesScreen />}/>
      <Route  path='/owner/reports/gratuity' element={<GratuityScreen />}/>














      
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
